import { SelectInput, type SelectInputProps } from "./SelectInput";
import { Input } from "./Input";
import { useId } from "react";
import { SelectItem } from "./Select";

export interface SelectInputOptionalProps
  extends Omit<SelectInputProps, "onValueChange" | "value"> {
  /** The current value of the select input */
  selectValue: string;
  /** The current value of the 'other' input */
  manualValue: string;
  /** onChange handler, passed the current select input and 'other' input values */
  onChange?: (selectValue: string, manualValue: string) => void;
  /** The label used for the 'other' option in the select dropdown */
  otherLabel?: string;
  /** The value assigned for the 'other' option. Be sure this **never** conflicts with other values provided for the select. This cannot be an empty string. */
  otherValue: string;
  /** Placeholder for the 'other' input */
  manualPlaceholder?: string;
}

export const SelectInputOptional = ({
  options,
  selectValue,
  manualValue,
  otherLabel = "Other",
  otherValue,
  onChange = () => {},
  manualPlaceholder,
  ...props
}: SelectInputOptionalProps) => {
  const id = useId();

  return (
    <>
      <SelectInput
        {...props}
        value={selectValue}
        onValueChange={(value) => {
          onChange(value, manualValue);
        }}
        options={[
          ...options,
          <SelectItem key={otherValue} value={otherValue}>
            {otherLabel}
          </SelectItem>,
        ]}
      />
      {selectValue === otherValue ? (
        <Input
          id={id}
          placeholder={manualPlaceholder}
          value={manualValue}
          onChange={(evt) => {
            onChange(selectValue, evt.target.value);
          }}
        />
      ) : null}
    </>
  );
};
